import React, { useMemo, useState } from 'react';
import { LectureItem } from './components/lecturer-item';
import globalCourseStore from '../../../stores/global-course-store';
import { LecturePart } from '../../../api/types/programs/course/lectures/course-lecture-part';
import { LectureCalendar } from './calendar/lecture-calendar';
import { Button } from 'primereact/button';
import { LecturesListView } from './list-view/lectures-list-view';
import {
  CreateCalendarScheduleDialog,
  ScheduleType,
} from '../../calendar/create-calendar-schedule-dialog';
import { SelectedSlotsState } from '../../calendar/tabs/serial/components/time-slots/types/selected-slots';
import { LecturerIdWithActivityTypeId } from '../../calendar/tabs/serial/create-lecture-serial-tab';
import globalProgramStore from '../../../stores/program-store';
import { createSerialLecturesOperations } from './calendar/big-calendar/operations/create-serial-lectures-operations';

export interface CourseLecturesDatamodel {
  isProfessor: boolean;
}

const CourseLectures: React.FC<CourseLecturesDatamodel> = ({ isProfessor }) => {
  const [displayList, setDisplayList] = useState(true);
  const [showDialogActive, setShowDialogActive] = useState(false);

  const [displaySchedule, setDisplaySchedule] = useState(false);

  const getLectureItems = useMemo(() => {
    let cumulativeIndex = 0;
    const lectures = globalCourseStore.courses.get(
      globalCourseStore.currentId!,
    )!.details!.lectures;
    return (
      <>
        {lectures.flatMap((lectureItem) => {
          cumulativeIndex = cumulativeIndex + 1;

          return (
            <LectureItem
              key={`${'lectureItem.metadata.id'}-${cumulativeIndex}`} // Ensure a unique key for each item
              data={{
                id: /*lectureItem.metadata.id*/ 1,
                index: cumulativeIndex,
                lecturePart: {
                  startTime: new Date(),
                  endTime: new Date(),
                  id: 1,
                  durationMinutes: 30,
                } as LecturePart,
                lectureSubject: lectureItem.item.lectureName,
                lecturer: [],
                classNumber: lectureItem.class.id,
                howManyPresent: 5,
                howManyPresentOutOf: 15,
                shouldAllowStartEndClass: true,
                shouldShowHowManyPresent: true,
              }}
            />
          );
        })}
      </>
    );
  }, []);

  const handleOnApproveCreateLectures = async (
    selectedSlotsState: SelectedSlotsState,
    lecturesIdsWithActivityTypeId: LecturerIdWithActivityTypeId[],
    setIsLoadingCreateLectures: (loading: boolean) => any,
    onHide: () => any,
    attendanceRequired?: boolean,
  ) => {
    const currentProgramId = globalProgramStore.getCurrentId();
    const currentCourse = globalCourseStore.getCurrentCourse();

    await createSerialLecturesOperations(
      currentProgramId,
      currentCourse?.metadata.id,
      lecturesIdsWithActivityTypeId,
      selectedSlotsState,
      setIsLoadingCreateLectures,
      onHide,
      attendanceRequired,
    );
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'left',
          gap: '8px',
          marginLeft: '8px',
        }}
      >
        <Button
          icon="pi pi-plus"
          rounded
          style={{ height: '30px', width: '30px' }}
          tooltip="להוספת הרצאה"
          aria-label="Add"
          visible={!isProfessor}
          onClick={() => setDisplaySchedule(true)}
        />
        {/*<Button
          style={{ height: '30px' }}
          label={'רשימה'}
          outlined={!displayList}
          onClick={() => setDisplayList(true)}
        />*/}
        {/*        <Button
          style={{ height: '30px' }}
          label={'לוח שנה'}
          outlined={displayList}
          onClick={() => setDisplayList(false)}
        />*/}
      </div>
      {displayList ? (
        <LecturesListView isProfessor={isProfessor} />
      ) : (
        <LectureCalendar />
      )}

      {displaySchedule && (
        <CreateCalendarScheduleDialog
          branchId={
            globalProgramStore.programs.get(globalProgramStore.getCurrentId())
              .metadata.branchId
          }
          courseName={
            globalCourseStore?.getCurrentCourse()?.metadata.abstractData
              .courseName ?? ''
          }
          supportMultiple={false}
          timeSlot={null}
          onApprove={handleOnApproveCreateLectures}
          onHide={() => setDisplaySchedule(false)}
          scheduleType={ScheduleType.LECTURE}
        />
      )}
    </div>
  );
};

export default CourseLectures;
